@if (format === FORMAT_TEXT_SINGLELINE) {
  <span>{{ fieldValue | formatLongText: 30 }}</span>
}
@if (format === FORMAT_TEXT_MULTILINE) {
  <div [innerHTML]="fieldValue" style="max-height: 45px; overflow: hidden"></div>
}
